// @flow

import _ from "lodash";
import * as React from "react";

import "./SearchResults.css";

type Props = {
  results: Array<Object>, // Current page's results
  handleClick: string => void,
  nextIndex: ?number, // Index of next page's results
  prevIndex: ?number // Index of previous page's results
};

const SearchResults = (props: Props) => (
  <div className="SearchResults">
    {props.results.map((result, i) => {
      return (
        <div className="SearchResults-Result" key={i}>
          <a
            className="SearchResults-Result-Title"
            href="#visit-link"
            onClick={e => {
              props.handleClick(result.link);
              e.preventDefault();
            }}
          >
            {result.title}
          </a>
          <div className="SearchResults-Result-Link">
            {_.truncate(result.link, { length: 100 })}
          </div>
          <div className="SearchResults-Result-Snippet">{result.snippet}</div>
        </div>
      );
    })}
  </div>
);

export default SearchResults;



// WEBPACK FOOTER //
// ./src/components/Google/SearchResults.js